<template>
  <div class="menu-setting-box">
    <a-card :title="$t('edit.editActionTitles.menuSets')" :bordered="false">
      <div class="add-menu-box" v-if="userInfo.level > 0 || userInfo.team_id > 0">
        <a-button block type="primary" @click="addMenu">{{'+ ' + $t('edit.addMenu')}}</a-button>
      </div>
      <div class="menu-settings" ref="middle">
        <div>
          <Menu-item
            v-for="item in menuList"
            :key="item.num"
            :selectOptions="selectOptions"
            :item="item"
            @del="delMenu"
            @changSource="changSource"
          ></Menu-item>
        </div>

        <a-row v-if="userInfo.level > 0 || userInfo.team_id > 0">
          <a-col span="8">
            <!-- <a-form-model layout="vertical" ref="ruleForm" :form="form" :rules="rules" :model="form">
            <a-form-model-item>-->
            <a-button type="primary" @click="handleSubmit">{{$t('actionTitles.submit')}}</a-button>
            <a-button style="margin-left: 10px;">{{$t('actionTitles.cancel')}}</a-button>
            <!-- </a-form-model-item>
            </a-form-model>-->
          </a-col>
        </a-row>
      </div>
    </a-card>
  </div>
</template>

<script>
import MenuItem from "./MenuItem.vue";
import { mapGetters } from "vuex";
export default {
  components: { MenuItem },
  data() {
    return {
      menuList: [],
      menuIndex: 0,
      selectOptions: [
        { id: 1, value: 1, title: this.$t("edit.link"), disabled: false },
        { id: 2, value: 2, title: this.$t("edit.phone"), disabled: false },
        { id: 3, value: 3, title: this.$t("edit.address"), disabled: false },
        { id: 4, value: 4, title: this.$t("edit.picText"), disabled: false },
        { id: 5, value: 5, title: this.$t("edit.video"), disabled: false },
      ],
    };
  },
  computed: { ...mapGetters(["vrbase","userInfo"]) },
  created() {
    this.menuList = this.$deepClone(this.vrbase.menus);
    if (this.menuList.length) {
      this.menuList.forEach((item) => {
        this.menuIndex++;
        item.num = this.menuIndex;
      });
      console.log("menuList Clone =>", this.menuList);
    }
  },
  methods: {
    handleSubmit() {
      console.log("menuList==save", this.menuList);
      for (var i = 0; i < this.menuList.length; i++) {
        const menu = this.menuList[i];
        if(menu.title === "" || menu.content === "") {
          this.$message.error(`${this.$t('edit.menu')}${menu.num}${this.$t('descriptions.noFinish')}`)
          return;
        }
      }
      const vrbase = { ...this.vrbase, menus: this.menuList }
      this.$store
        .dispatch("saveVRBase", { vrbase, showLoading: true, })
        // .then(() => {
        //   // this.$message.success(this.$t("message.saveSuccess"));
        // });
    },
    addMenu() {
      this.menuIndex++;
      this.menuList.push({
        num: this.menuIndex,
        title: "",
        type: null,
      });
      this.$nextTick(() => {
        let middle = this.$refs["middle"];
        middle.scrollTop = middle.scrollHeight;
      });
    },
    delMenu(num) {
      let index = null;
      this.menuList.find((v, i, arr) => {
        if (v.num === num) {
          index = i;
          return;
        }
      });
      this.menuList.splice(index, 1);
      const length = this.menuList.length;
      if (length > 0) {
        this.menuIndex = length;
      } else {
        this.menuIndex = 0;
      }
    },
    changSource(item) {
      const num = item.num;
      this.menuList.forEach((v, i) => {
        if (v.num === num) {
          this.$set(this.menuList, i, {
            ...item,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-menu-box {
  position: absolute;
  top: -45px;
  right: 20px;
  z-index: 100;
}
.submitBtn {
  background-color: #7101ad;
  border-color: #7101ad;
}
.submitBtn:hover{
  background-color: #d485ff;
  border-color: #d485ff;
}
.submitBtn:focus{
  background-color: #d485ff;
  border-color: #d485ff;
}
.addMenuBtn {
  background-color: #7101ad;
  border-color: #7101ad;
}
.addMenuBtn:hover{
  background-color: #d485ff;
  border-color: #d485ff;
}
.addMenuBtn:focus{
  background-color: #d485ff;
  border-color: #d485ff;
}
</style>
<style>
.vr-bg .menu-setting-box .ant-card-body {
  position: relative;
  overflow-y: initial;
  padding: 0;
}
.menu-setting-box .ant-card-body > .menu-settings {
  padding: 24px;
  overflow-y: auto;
  height: 100%;
}
</style>
